const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export async function getCampus() {
  // Usar endpoint optimizado para selects
  try {
    const res = await fetch(`${API_BASE}/catalogos/campus/select/`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) {
      console.error('[campus.js] Error en respuesta:', res.status, res.statusText);
      return [];
    }
    const data = await res.json();
    // Mapear solo los campos mínimos
    if (Array.isArray(data) && data.length > 0) {
      return data.map(c => ({
        id: c.id_campus,
        nombre: c.nombre_campus,
        codigo: c.codigo_campus,
        institucion: c.id_institucion
      }));
    }
    return [];
  } catch (err) {
    console.error('[campus.js] Error al cargar campus:', err);
    return [];
  }
}

export async function createCampus(form) {
  const payload = {
    nombre_campus: form.nombre,
    codigo_campus: form.codigo,
    id_institucion: Number(form.institucion?.id || form.institucion),
    direccion: form.direccion,
    telefono: form.telefono,
    email: form.email,
    activo: form.estado === 'ACTIVO',
    // Agrega más campos según tu modelo
  };
  const res = await fetch(`${API_BASE}/catalogos/campus/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al crear campus');
  return await res.json();
}

export async function updateCampus(id, form) {
  const payload = {
    nombre_campus: form.nombre,
    codigo_campus: form.codigo,
    id_institucion: Number(form.institucion?.id || form.institucion),
    direccion: form.direccion,
    telefono: form.telefono,
    email: form.email,
    activo: form.estado === 'ACTIVO',
    // Agrega más campos según tu modelo
  };
  const res = await fetch(`${API_BASE}/catalogos/campus/${id}/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al actualizar campus');
  return await res.json();
}

export async function deleteCampus(id) {
  const res = await fetch(`${API_BASE}/catalogos/campus/${id}/`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error('Error al eliminar campus');
  return true;
}
